"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get SYNTHETIC_EMAIL_DOMAIN () {
        return SYNTHETIC_EMAIL_DOMAIN;
    },
    get isSyntheticEmail () {
        return isSyntheticEmail;
    }
});
const SYNTHETIC_EMAIL_DOMAIN = "noemail.performyard.com";
const isSyntheticEmail = (email)=>{
    if (!email) return false;
    return email.toLowerCase().endsWith(`@${SYNTHETIC_EMAIL_DOMAIN}`);
};
